import { render } from "./GlossaireModal.vue?vue&type=template&id=2710c575&scoped=true"
import script from "./GlossaireModal.vue?vue&type=script&lang=js"
export * from "./GlossaireModal.vue?vue&type=script&lang=js"

import "./GlossaireModal.vue?vue&type=style&index=0&id=2710c575&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2710c575"

export default script